window.theme = window.theme || {};

theme.Currency = (function() {
  const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  };
})();

class PageCounter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.countInput = this.querySelector('[product-page-counter]');
    this.copiesInput = this.querySelector('[product-copies-counter]');
    this.quantityInput = this.querySelector('[name="quantity"]');
    this.currentQuantity = 1;

    this.only_copy = false;

    if(this.hasAttribute('data-no-count')) this.only_copy = true;

    
    if( !this.copiesInput || !this.quantityInput) return;
    
    this.countInput?.addEventListener('input', this.adjustQuantity.bind(this));
    this.copiesInput.addEventListener('input', this.adjustQuantity.bind(this));

    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.adjustPrice.bind(this)
    );
    this.adjustPrice();
  }

  adjustQuantity(){
    
    const countInputValue = this.only_copy ? 1 : this.countInput.value.trim();
    const copiesInputValue = this.copiesInput.value.trim();

    const count = Number(countInputValue);
    const copies = Number(copiesInputValue);

    const errorElement = this.querySelector('.page-counter-error');

    if (!countInputValue || !copiesInputValue || isNaN(count) || isNaN(copies)) {
        if(errorElement){
            errorElement.textContent = 'Please enter valid numbers';
            return;
        }
    }else{
        if(errorElement) errorElement.textContent = '';
    }

    this.quantityInput.value = count * copies;
    this.currentQuantity = count * copies;
    this.adjustPrice();
  }

  adjustPrice(){
    const currentPrice = this.querySelector('input[product-price]')?.value;
    const priceElementId = this.dataset.priceId;
    if(!currentPrice || !priceElementId) return;

    let totalPrice = currentPrice * this.currentQuantity;
    const addon = document.querySelector("input[name='extra-addon']:not([value='0']):checked");
    if(addon){
      totalPrice = totalPrice + (Number(addon.dataset.price) * Number(this.copiesInput.value));
    }
    totalPrice = theme.Currency.formatMoney(totalPrice, window.shopSettings.moneyFormat);

    const priceElement = document.querySelectorAll(`#${priceElementId} .price__regular .price-item--regular`);
    const priceSaleElement = document.querySelectorAll(`#${priceElementId} .price__sale .price-item--sale`);

    priceElement.forEach(e=>{
      e ? window.shopSettings.currencyCode ? e.innerHTML = totalPrice + " " + window.shopSettings.isoCode : e.innerHTML = totalPrice : "";
    })
    priceSaleElement.forEach(e=>{
      e ? window.shopSettings.currencyCode ? e.innerHTML = totalPrice + " " + window.shopSettings.isoCode : e.innerHTML = totalPrice : "";
    })
        
  }

}
customElements.define("page-counter", PageCounter);

document.addEventListener('DOMContentLoaded', function() {

  const addonInputs = document.querySelectorAll('input[name="extra-addon"]');
  if(addonInputs.length){
    addonInputs.forEach(e=>{
      e.addEventListener('change',function(){
        setTimeout(()=>{
          const pageCounter = document.querySelector('page-counter');
          const quantityInput = pageCounter?.querySelector('[name="quantity"]');
          const currentPrice = pageCounter?.querySelector('input[product-price]')?.value;
          const copiesInput = pageCounter?.querySelector('[product-copies-counter]');
          const priceElement = document.querySelectorAll(`#${pageCounter.dataset.priceId} .price__regular .price-item--regular`);
          const priceSaleElement = document.querySelectorAll(`#${pageCounter.dataset.priceId} .price__sale .price-item--sale`);
          if(!currentPrice || !quantityInput || !copiesInput) return;

          let totalPrice = currentPrice * Number(quantityInput.value);
          const addon = document.querySelector("input[name='extra-addon']:not([value='0']):checked");
          if(addon){
            totalPrice = totalPrice + (Number(addon.dataset.price) * Number(copiesInput.value));
          }
          totalPrice = theme.Currency.formatMoney(totalPrice, window.shopSettings.moneyFormat);

          priceElement.forEach(e=>{
            e ? window.shopSettings.currencyCode ? e.innerHTML = totalPrice + " " + window.shopSettings.isoCode : e.innerHTML = totalPrice : "";
          })
          priceSaleElement.forEach(e=>{
            e ? window.shopSettings.currencyCode ? e.innerHTML = totalPrice + " " + window.shopSettings.isoCode : e.innerHTML = totalPrice : "";
          })
          
        },10)
      })
    })
  }

  const containers = document.querySelectorAll('.product-tooltip-info-container');
  
  if(!containers.length) return;

  function adjustTooltip(ele){
    setTimeout(() => {
        // Reset classes
        const tooltip = ele.querySelector('.tooltip');
        tooltip.className = 'tooltip rte';
        
        const rect = ele.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        
        const tooltipWidth = 250; // approximate width
        const tooltipHeight = 40; // approximate height
        
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        const spaceRight = viewportWidth - rect.right;
        const spaceLeft = rect.left;
        
        if (spaceBelow >= tooltipHeight + 15) {
        } else if (spaceAbove >= tooltipHeight + 15) {
            tooltip.classList.add('top');
        } else if (spaceRight >= tooltipWidth + 15) {
            tooltip.classList.add('right');
        } else if (spaceLeft >= tooltipWidth + 15) {
            tooltip.classList.add('left');
        }
    }, 10);
  }
  containers.forEach(e=>{
    e.addEventListener('mouseenter', function(){
      adjustTooltip(this);
    });
    e.addEventListener('touchstart', function(){
      adjustTooltip(this);
    });
  })
  
});
